import { render, staticRenderFns } from "./ManualReserveProgramInfo.vue?vue&type=template&id=47296318&"
import script from "./ManualReserveProgramInfo.vue?vue&type=script&lang=ts&"
export * from "./ManualReserveProgramInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports